import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_OZF_67 } from "@/lib/programs/ouarzazateSidialiFez67";

export default function OuarzazateSidialiFez67Page() {
  return <ProgramTemplate program={PROGRAM_OZF_67} variant="ozf" showJourneyChronology />;
}
